import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { MessageCircle, X } from 'lucide-react';
import { FaViber, FaWhatsapp } from 'react-icons/fa';

const WHATSAPP_NUMBER = '37367818180';
const VIBER_NUMBER = '37367818180';

const FloatingChatButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  if (location.pathname.startsWith('/admin')) {
    return null;
  }

  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}`;
  const viberUrl = `viber://chat?number=%2B${VIBER_NUMBER}`;

  return (
    <div className="pointer-events-none fixed bottom-20 right-5 z-[9999] flex flex-col items-end gap-3 md:bottom-5">
      <div
        className={`flex flex-col items-end gap-3 transition-all duration-300 ease-out ${
          isOpen
            ? 'translate-y-0 opacity-100'
            : 'translate-y-4 opacity-0'
        }`}
        aria-hidden={!isOpen}
      >
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          tabIndex={isOpen ? 0 : -1}
          className={`group flex items-center gap-3 ${
            isOpen ? 'pointer-events-auto' : 'pointer-events-none'
          }`}
          aria-label="WhatsApp"
        >
          <span className="rounded-lg bg-white px-3 py-2 text-sm font-semibold text-gray-800 opacity-0 translate-x-2 transition-all duration-200 group-hover:opacity-100 group-hover:translate-x-0">
            WhatsApp
          </span>

          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-[#25D366] text-white transition hover:scale-105">
            <FaWhatsapp className="h-9 w-9" />
          </span>
        </a>

        <a
          href={viberUrl}
          tabIndex={isOpen ? 0 : -1}
          className={`group flex items-center gap-3 ${
            isOpen ? 'pointer-events-auto' : 'pointer-events-none'
          }`}
          aria-label="Viber"
        >
          <span className="rounded-lg bg-white px-3 py-2 text-sm font-semibold text-gray-800 opacity-0 translate-x-2 transition-all duration-200 group-hover:opacity-100 group-hover:translate-x-0">
            Viber
          </span>

          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-[#7360F2] text-white transition hover:scale-105">
            <FaViber className="h-9 w-9" />
          </span>
        </a>
      </div>

      <button
        type="button"
        onClick={() => setIsOpen((value) => !value)}
        className="pointer-events-auto flex h-16 w-16 items-center justify-center rounded-full bg-lime-400 text-white transition hover:scale-105 hover:bg-lime-300"
        aria-label={isOpen ? 'Închide chat' : 'Deschide chat'}
        aria-expanded={isOpen}
      >
        <span className="relative flex h-8 w-8 items-center justify-center">
          <MessageCircle
            className={`absolute h-8 w-8 transition-all duration-300 ${
              isOpen
                ? 'rotate-90 scale-0 opacity-0'
                : 'rotate-0 scale-100 opacity-100'
            }`}
          />

          <X
            className={`absolute h-8 w-8 transition-all duration-300 ${
              isOpen
                ? 'rotate-0 scale-100 opacity-100'
                : '-rotate-90 scale-0 opacity-0'
            }`}
          />
        </span>
      </button>
    </div>
  );
};

export default FloatingChatButton;